import { render, staticRenderFns } from "./MapDetailHeader.vue?vue&type=template&id=7f28552d"
import script from "./MapDetailHeader.vue?vue&type=script&lang=js"
export * from "./MapDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports